import * as React from 'react';
import { message, Modal } from 'src/design-system/components/atoms';
import FixedHeaderTable from 'src/design-system/components/molecules/FixedHeaderTable/FixedHeaderTable';
import { bindActionCreators } from 'redux';
import { fetchObjectFieldListMetadata } from 'src/actions/jsonArrayTableViewActions';
import { ObjectFieldDataType } from '../setup/WorkFlowBuilder/utils/constants';
import { connect } from 'react-redux';

interface IProps {
  isVisible: boolean;
  handleClose: () => void;
  data: any;
  objectType: string;
  fetchObjectFieldListMetadata: (params: any) => void;
  errorMessage: string;
  isLoading: boolean;
  fieldListMetadata: any;
  columnKey: string;
  sendAllFields: boolean;
}

const JsonArrayTableViewModal = (props: IProps) => {
  const {
    isVisible,
    handleClose,
    data,
    objectType,
    fetchObjectFieldListMetadata,
    errorMessage,
    isLoading,
    fieldListMetadata,
    columnKey,
    sendAllFields,
  } = props;
 
  const sendCustomFieldsOnly = sendAllFields ? false : true;
  React.useEffect(() => {
    if (!fieldListMetadata?.[objectType]) {
      fetchObjectFieldListMetadata({
        objectType,
        sendCustomFieldsOnly,
      });
    }
  }, []);

  React.useEffect(() => {
    if (errorMessage) {
      message.error(errorMessage);
    }
  }, [errorMessage]);

  const getColumnsForTable = () => {
    const columns: any = [];
    const fieldsList = fieldListMetadata?.[objectType]?.find(field => field.id === columnKey)?.formUIComponent?.fields ?? [];

    fieldsList.forEach((field, index) => {
      columns.push({
        dataIndex: index,
        title: field.prettyName,
        key: field.id,
        render: (_, record) => {
          if (field.dataType === ObjectFieldDataType.Boolean && typeof record[field.id] === 'boolean') {
            return record[field.id] ? 'Yes' : 'No';
          } else {
            return record[field.id] ?? '-';
          }
        },
        width: '200px',
      });
    });
    return columns;
};

  return (
    <Modal
      title={'Details'}
      width={800}
      visible={isVisible}
      footer={null}
      onCancel={() => handleClose()}
      destroyOnClose
    >
      <FixedHeaderTable
        columns={getColumnsForTable()}
        dataSource={data}
        loading={isLoading}
        pagination={false}
        scroll={{ x: 'max-content' }}
        minHeight={300}
      />
    </Modal>
  );
};

const mapStateToProps = ({ jsonArrayTableViewReducer }, ownProps) => {
  return {
    isLoading: jsonArrayTableViewReducer.isLoading,
    fieldListMetadata: jsonArrayTableViewReducer.fieldListMetadata,
    errorMessage: jsonArrayTableViewReducer.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchObjectFieldListMetadata,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(JsonArrayTableViewModal);
